<template>
	<section>
		<loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>

        <ul id="tabs-configuracao-avaliacao" class="tabs">
          <li class="tab"><a class="active" href="#geral">Geral</a></li>

          <li class="tab"
              v-for="(grupo, grupo_i) in grupos_avaliacao"
              :key="grupo_i"><a :href="`#${grupo_i}`">{{ grupo.descricao }}</a></li>
        </ul>
		<br>
		<fieldset>
			<div id="geral" class="col s12">
				<div class="row">
					<div class="col s12">

						<div class="row">

							<div class="input-field col s12">
								<!-- JUSTIFICATIVA -->
								<select name="justificativa_qtd_caracteres"
										id="justificativa_qtd_caracteres"
										ref="justificativa_qtd_caracteres"
										class="materialize-select"
										v-model.number="configuracao_padrao.quantidade_caracteres_justificativa"
										:disabled='bloqueio == true'>
								  <option value="" disabled>Selecione uma opção</option>
								  <option value="500">500 caracteres</option>
								  <option value="1000">1000 caracteres</option>
								  <option value="1500">1500 caracteres</option>
								</select>
								<label for="justificativa_qtd_caracteres">Quantidade de Caracteres da Justificativa</label>
							</div>

							<div class="input-field col s12">
								<!-- PARECER -->
								<select name="parecer_qtd_caracteres"
										id="parecer_qtd_caracteres"
										ref="parecer_qtd_caracteres"
										class="materialize-select"
										v-model.number="configuracao_padrao.quantidade_caracteres_parecer"
										:disabled='bloqueio == true'>
								  <option value="" disabled>Selecione uma opção</option>
								  <option value="1500">1500 caracteres</option>
								  <option value="2000">2000 caracteres</option>
								  <option value="2500">2500 caracteres</option>
								</select>
								<label for="parecer_qtd_caracteres">Quantidade de Caracteres do Parecer</label>
							</div>

							<div class="input-field col s12">
								<!-- RECURSO -->
								<select name="recurso_qtd_caracteres"
										id="recurso_qtd_caracteres"
										ref="recurso_qtd_caracteres"
										class="materialize-select"
										v-model.number="configuracao_padrao.quantidade_caracteres_recurso"
										:disabled='bloqueio == true'>
								  <option value="" disabled>Selecione uma opção</option>
								  <option value="1000">1000 caracteres</option>
								  <option value="1500">1500 caracteres</option>
								  <option value="2000">2000 caracteres</option>
								</select>
								<label for="parecer_qtd_caracteres">Quantidade de Caracteres do Recurso e Resposta do Recurso</label>
							</div>

						</div>

					</div>

				</div>
			</div>

			<div v-for="(grupo, grupo_i) in grupos_avaliacao"
				 :key="grupo_i"
				 :id="grupo_i">

			  <div class="row">

				<div class="col s12">

					<template v-for='modalidade in mods'>
						<h5>{{modalidade.descricao}}</h5>
						<template v-for="(item, item_i) in listaItensPorGrupo(grupo.id)">
							<div v-if='item.modalidade == modalidade.descricao'>

							  <div class="input-field col s6">
								<input type="text"
									   :id="'descricao_item_' + item.id"
									   :ref="'descricao_item_' + item.id"
									   name="descricao_item"
									   :value="!item.label ? item.nome : item.label"
									   readonly>
								<label :for="'descricao_item_' + item.id">Item</label>
							  </div>

							  <div class="input-field col s2">
								<input type="number"
									   :id="'nota_minima_item_' + item.id"
									   :ref="'nota_minima_item_' + item.id"
									   name="nota_minima_item"
									   maxlength="2"
									   v-model.number="item.nota_min"
									   :readonly='bloqueio == true'>
								<label :for="'nota_minima_item_' + item.id">Nota mínima</label>
							  </div>

							  <div class="input-field col s2">
								<input type="number"
									   :id="'nota_maxima_item_' + item.id"
									   :ref="'nota_maxima_item_' + item.id"
									   name="nota_maxima_item"
									   maxlength="2"
									   v-model.number="item.nota_max"
									   :readonly='bloqueio == true'>
								<label :for="'nota_maxima_item_' + item.id">Nota máxima</label>
							  </div>

							  <div class="input-field col s2">
								<select name="variacao_da_nota"
										:id="'variacao_da_nota_item_' + item.id"
										:ref="'variacao_da_nota_item_' + item.id"
										class="materialize-select"
										v-model="item.nota_var"
										:disabled='bloqueio == true'>
								  <option value="" disabled>Escolha um valor</option>
								  <option value="0.1">0.1</option>
								  <option value="0.5">0.5</option>
								  <option value="1">1.0</option>
								</select>
								<label :for="'variacao_da_nota_item_' + item.id">Variação da nota</label>
							  </div>

							</div>
						</template>
						<br><br>
					</template>
				  </div>

				</div>

			  </div>

			</div>

			<div class="row">
			  <div class="col s12">
				&nbsp;
				<button type="button" v-if='!bloqueio'
						class="btn waves-effect waves-light indigo"
						@click.prevent="salvaDados">
				  <i class="material-icons left">save</i>
				  Salvar
				</button>
			  </div>
			</div>
		</fieldset>
	</section>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: "configuracao_avaliacao",
  components: {Loading},
  props: {
    configuracaoPadrao: {
      type: String,
      default: null,
    },
    gruposAvaliacao: {
      type: String,
      default: null,
    },
	modalidades: {
      type: String,
      default: null,
    },
	bloqueio: {
		type: String,
		default: null,
	}
	
  },
  data() {
    return {
      configuracao_padrao: JSON.parse(this.configuracaoPadrao),
      grupos_avaliacao: JSON.parse(this.gruposAvaliacao),
      mods: JSON.parse(this.modalidades),
	  loading: false,
    }
  },
  methods: {
    listaItensPorGrupo(grupo) {
        const itens = _.filter(this.configuracao_padrao.itens_da_avaliacao, (item) => {
            return item.grupo === grupo
        })

        return _.orderBy(itens, ['campo_referente_na_inscricao', 'ordem'], ['desc', 'asc'])
    },

    async salvaDados() {
      this.loading = true

      await this.$http.put('/api/configuracoes-avaliacao/' + this.configuracao_padrao.id, this.configuracao_padrao).then(response => {
        Swal.fire('Sucesso!', response.body.msg, 'success')
      }, error => {
        Swal.fire({ title: 'Ocorreu um erro!', text: error.body.msg, footer: error.body.exception, icon: 'error'})
      })

      this.loading = false
    }
  },
}
</script>

<style scoped>

</style>